import { MessageSquare, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

interface ChatBubbleProps {
  isOpen: boolean;
  onToggle: () => void;
  messageCount?: number;
}

export const ChatBubble = ({ isOpen, onToggle, messageCount = 0 }: ChatBubbleProps) => {
  const isMobile = useIsMobile();

  // On mobile, the bottom bar handles the chat button
  if (isOpen || isMobile) return null;

  return (
    <Button
      onClick={onToggle}
      size="icon"
      className="fixed bottom-20 right-5 z-50 h-14 w-14 rounded-full shadow-lg hover:shadow-xl transition-all animate-in slide-in-from-bottom-5 bg-gradient-to-br from-primary to-primary/80"
    >
      <MessageSquare className="h-6 w-6" />
      {messageCount > 0 && (
        <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-destructive text-destructive-foreground text-xs flex items-center justify-center">
          {messageCount > 9 ? '9+' : messageCount}
        </span>
      )}
    </Button>
  );
};
